import { stats } from '@fiverr-private/obs';

const METRIC_PREFIX = 'packages.gig_listings';

export const metric = stats.prefix(METRIC_PREFIX);
